import { render, staticRenderFns } from "./feeDetailContract.vue?vue&type=template&id=0c818bb0"
import script from "./feeDetailContract.vue?vue&type=script&lang=js"
export * from "./feeDetailContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports